import { useEffect, useState } from 'react';

/**
 * This function is like useDebounce, except that it only delays the value when
 * it is true. When the value is false, it immediately returns false.
 */
export function useDebounceTrue(value: boolean, ms: number) {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		if (value) {
			const handler = setTimeout(() => {
				setDebouncedValue(value);
			}, ms);

			return () => clearTimeout(handler);
		} else {
			setDebouncedValue(false);
		}
	}, [value, ms]);

	return debouncedValue;
}
